import apiAuth from './apiAuth'

const AuthServices = {
  async login(info) {
    const data = `grant_type=password&scope=openid&username=${info.username}&password=${info.password}`
    const res = await apiAuth.post('/token', data)
    return res.data
  },
  async refreshUserToken(refreshToken) {
    const data = `grant_type=refresh_token&refresh_token=${refreshToken}`
    const res = await apiAuth.post('/token', data)
    return res.data
  },
}

export default AuthServices
